import React from 'react';
import Icon from '../../../components/AppIcon';

const steps = [
  {
    icon: 'Search',
    title: 'Search Properties',
    desc: 'Browse verified listings and filter by city, budget, type and amenities.',
  },
  {
    icon: 'Calendar',
    title: 'Schedule Viewing',
    desc: 'Book a visit at your convenience and meet the owner directly — no broker.',
  },
  {
    icon: 'CheckCircle',
    title: 'Apply & Verify',
    desc: 'Submit your application and complete KYC verification in minutes.',
  },
  {
    icon: 'Key',
    title: 'Move In',
    desc: 'Sign the rental agreement digitally, pay securely, and collect your keys.',
  },
];

const SuccessMetrics = () => {
  return (
    <section className="py-14 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 tracking-tight">
            How It Works
          </h2>
          <p className="text-gray-500 mt-3 text-base sm:text-lg">
            Four simple steps to find and rent your dream home
          </p>
        </div>

        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
          {steps.map((step, i) => (
            <li key={step.title} className="relative text-center">
              {/*
                Connector rail. Sits at the circle's vertical centre (half of
                h-28 = 3.5rem) and spans the gap between adjacent circles, so
                it starts where one circle ends and stops where the next
                begins. Hidden on the last item and below lg, where the grid
                reflows and a horizontal rail would point at nothing.
              */}
              {i < steps.length - 1 && (
                <span
                  aria-hidden="true"
                  className="hidden lg:block absolute top-14 left-[calc(50%+3.5rem)] w-[calc(100%-7rem+1.5rem)] h-px bg-rose-200"
                />
              )}

              <div className="relative inline-flex mb-6">
                <span className="w-28 h-28 rounded-full bg-rose-500 text-white flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(244,63,94,0.45)]">
                  <Icon name={step.icon} size={44} strokeWidth={1.75} />
                </span>
                {/* Step number, notched into the lower-right of the circle */}
                <span className="absolute -bottom-1 -right-1 w-10 h-10 rounded-full bg-white ring-4 ring-gray-50 text-rose-500 text-sm font-semibold flex items-center justify-center">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>

              <h3 className="text-xl font-semibold text-gray-900">{step.title}</h3>
              <p className="text-[15px] text-gray-500 leading-relaxed mt-2 max-w-xs mx-auto">
                {step.desc}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default SuccessMetrics;
